<template>
  <Multiselect
              :class="{'multiselect-sm': small}"
               class=""
               v-model="vModel"
              :disabled="disabled"
               :options="admins"
               :custom-label="(opt) => `${opt.name} (${opt.email})`"
               track-by="id"
               select-label="Select"
               :placeholder="multiple ? helper.trans('labels.admins') : helper.trans('labels.admin')"
               open-direction="bottom"
               :multiple="multiple"
               :searchable="true"
               :loading="isLoading"
               :internal-search="false"
               :clear-on-select="!multiple"
               :close-on-select="!multiple"
               :options-limit="100"
               :limit="1000"
               :show-no-results="false"
               :hide-selected="multiple"
               @search-change="asyncFindAdmins"
  >
  </Multiselect>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType} from 'vue'
import {debounce, helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import APIClient from "@/service/APIClient";
import PaginationDTO from "@/models/PaginationDTO";
import {UserRole} from "@/models/enum/UserRole";
import UserDTO from "@/models/UserDTO";

const api = new APIClient()

export default defineComponent({
  emits: ['update:modelValue'],
  components: {
    Multiselect
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    } as Prop<boolean>,
    multiple: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    small: {
      type: Boolean,
      default: true
    } as Prop<boolean>,
    modelValue: {
      type: Object as PropType<any>,
      default: null
    } as Prop<any>,
  },
  setup(props, {emit}) {

    const state = reactive({
      isLoading: false as boolean,
      admins: [] as UserDTO[]
    })

    const asyncFindAdmins = debounce(async (query) => {
      state.isLoading = true
      state.admins = (await api.users({limit: 100, offset: 0} as PaginationDTO, {query: query, roles: [UserRole.ADMIN, UserRole.OPERATOR]})).items;
      state.isLoading = false
    }, 500);

    const vModel = computed({
      get(): any {
        return props.modelValue
      },
      set(value: any): void {
        emit('update:modelValue', value);
      },
    });

    onMounted(() => {
      asyncFindAdmins('')
    });

    return {
      ...toRefs(state),
      vModel,
      asyncFindAdmins,
      helper,
      numberFormatter
    }
  }
})
</script>
